import { render, staticRenderFns } from "./ManageService.vue?vue&type=template&id=19a54a7c&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./ManageService.vue?vue&type=style&index=0&id=19a54a7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a54a7c",
  null
  
)

export default component.exports